import { Service } from '@angular/core';

@Service()
export class UtilsService {
  getNewDateAfterHours(hoursNumber: number): string {
    const expiresDate: Date = new Date();
    const expiresHour: number = expiresDate.getHours() + hoursNumber;

    expiresDate.setHours(expiresHour);

    return expiresDate.toISOString();
  }

  getHashCode(value: string | null | undefined): number | null {
    if (!value) {
      return null;
    }

    return value.split('').reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);

      return a & a;
    }, 0);
  }

  isHashKeyCorrect(val: string, hashKey: string): boolean {
    const objHash = localStorage.getItem(hashKey);

    const hashCode = this.getHashCode(val);

    return hashCode !== null && objHash === hashCode.toString();
  }
}
